import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource, invalidateResource } from "kea-resource";

import { FiltroComponent } from "./filtro";
import { CargaDescargaCajaRutaDtoList } from "./list";

type Entity = models.CargaDescargaFiltro;

export interface Props {
    value?: Entity;
    onChange: (x: Entity) => void;
}
class ListFiltroCargasDescargasControlled extends React.PureComponent<Props> {
    onRefrescar = async () => {
        await invalidateResource(resources.CargaDescarga);
    }

    filtro = (props: Props) => 
    {
        return props.value || {Limite:100, Status: models.StatusCargaDescarga.EnProceso} as models.CargaDescargaFiltro;
    }
    items = createSelectorRx(this.filtro, filtro => observeResource(resources.CargaDescarga.ConsultarCargasDescargas, filtro ));

    render() {
        const filtro = this.filtro(this.props);
        const items = this.items(this.props);
        return (
            <div>
                <FiltroComponent value={filtro} onChange={this.props.onChange} />
                <CargaDescargaCajaRutaDtoList value={items} />
            </div>)
    }
}

export const ListFiltroCargasDescargas = kea.makeUncontrolledCookies<Partial<Props>>("value", "onChange")(ListFiltroCargasDescargasControlled);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cargacajaruta/list/cargasdescargas/listfiltro.tsx